import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm';
import PaymentForm from './PaymentForm';
import Review from './Review';
import { connect } from 'react-redux';
import {
  // addSubjects, 
  socialComunitiAction, 
  // deleteSubject,
  // clearSubject,
  // editSubject,
  // setSubjects,
  // saveEditableSubject,
  localityAction,
  setLocality
} from '../../../redux/actions/socialComuniti.action'
// import queryString from "query-string";
import { setCatalogs, getCatalogs } from '../../../redux/actions/catalog.action'
import {postRequest} from '../../../api/api'
import {loginUser, setCurrentUser, logoutUser} from '../../../redux/actions/auth.action'
// import {isEmpty} from '../utils/is-empty'
// import setAuthToken from '../utils/setAuthToken.js'
import { IconButton, List, ListItem, ListItemText } from '@material-ui/core';
import { Home } from 'react-feather';
// import { User } from 'react-feather';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'© '}
      <Link color="inherit" href="https://ioc.gov.ua">
        ІОЦ
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  width: "100%",
  "@media (min-width: 576px)": {
    maxWidth: "540px"
  },
  "@media (min-width: 768px)": {
    maxWidth: "720px"
  },
  "@media (min-width: 992px)": {
    maxWidth: "960px"
  },
  "@media (min-width: 1200px)": {
    maxWidth: "1140px"
  }
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  buttonPossition: {
    position: 'relative',
    // borderRadius: theme.shape.borderRadius,
    // backgroundColor: fade(theme.palette.common.white, 0.15),
    // '&:hover': {
    //   backgroundColor: fade(theme.palette.common.white, 0.25),
    // },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
    logoutButton: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      flexGrow: 1,
      // display: 'none',
      // [theme.breakpoints.up('sm')]: {
      //   display: 'block',
      // },
    },
  }
}));

const steps = ['Інформація про об’єднану територіальну громаду та її Голову', "Суб'єкти, у яких буде застосовано МШ та контакти", 'Перегляд заяви'];

function getStepContent(step, props, handleNext, handleNextTable, handleBack, validity, handleSubmit) {
  switch (step) {
    case 0:
      return <AddressForm reduxState={props} handleNext={handleNext} displayErrors={validity}/>;
    case 1:
      return <PaymentForm handleNextTable={handleNextTable} handleBack={handleBack}/>;
    case 2:
      return <Review handleSubmit={handleSubmit} handleBack={handleBack}/>;
    default:
      throw new Error('Unknown step');
  }
}

const mapStateToProps = (state) => ({
  catalog: state.catalogs,
  socialCommunity: state.socialCommunity

})

export default connect(mapStateToProps, {setLocality, socialComunitiAction, getCatalogs, setCatalogs, localityAction, loginUser, setCurrentUser, logoutUser}) (function Checkout(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [validity, setValidity] = React.useState(false)

  const handleNext = (event) => {
    event.preventDefault();

    if (!event.target.checkValidity()) {
      // console.log(!event.target.checkValidity());
      setValidity(true)
      return;
    } else {
      setActiveStep(activeStep + 1);
      setValidity(false)
    }
  };

  const handleNextTable = () => {
 
      setActiveStep(activeStep + 1);
    
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  React.useEffect(() => {

  }, [])

  const handleSubmit = async () => {
    // console.log('submit');

    const requestDetails = props.socialCommunity.requestDetails.map((item) => ({
      ...item,
      phone: item.phone.replace(/[-()\s]/g, "")
    }))

    const data = {
      ...props.socialCommunity,
      // communityPhone: props.socialCommunity.communityPhone.replace(/[\D]/g, "")
      communityPhone: props.socialCommunity.communityPhone.replace(/[-()\s]/g, ""),
      requestDetails
    }

    try {
      const response = await postRequest(data)

      if (response.status === 200) {

        setActiveStep(activeStep + 1);
      }
      
    } catch (error) {
      console.log(error);
    }
    
  }

  const handleLogout = () => {
    props.logoutUser()
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="static" color="primary" className={classes.appBar}>
        <Toolbar>
          <Typography className={classes.title} edge="start" variant="h6" color="inherit" noWrap>
          Контакт-центр ДП "ІОЦ Мінсоцполітики України" - (044)494-19-10
          </Typography>
          <div className={classes.buttonPossition}>
            <IconButton onClick={handleLogout}  color="inherit"><Home/></IconButton>
          </div>
            {/* <Typography className={classes.title} variant="h6" color="inherit" noWrap>
            Контакт-центр ДП "ІОЦ Мінсоцполітики України" - (044)494-19-10
            </Typography> */}
        </Toolbar>
      </AppBar>
      <main className={classes.layout}>
       
      <Grid container justify="center">
          
        
        <Paper className={classes.paper}>
       
          {/* <Grid item xs={12} sm={12} md={12}> */}
          <Typography component="h1" variant="h4" align="center">
          Електронна заявка про намір на укладання договору для отримання модуля(лів) 
шифрування (МШ) для підключення до крипто-мережі Мінсоцполітики України.

          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <React.Fragment>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography variant="h5" gutterBottom>
                Дякуємо за співпрацю та бажання підключити громаду до програмного комплексу “Інтегрована інформаційна система ”Соціальна громада” (далі - Комплекс).
                </Typography>
                <Typography variant="subtitle1">
                Ваша Заявка прийнята до обробки.
                </Typography>
                <Typography variant="subtitle1">
                Найближчим часом на адресу офіційної електронної пошти (далі — офіційна пошта), яку Ви вказали у Заявці, Ви отримаєте лист-підтвердження про те, що Заявку взято до обробки.
                </Typography>
                <Typography variant="subtitle1">
                В разі успішної обробки Заявки, на офіційну пошту Ви отримаєте електронного листа з Договором про надання послуг у сфері інформатизації (із забезпечення працездатності програмного комплексу “Криптосервер: Модуль шифрування”) та електронного листа з модулем(ями) шифрування, в якому містяться:
                </Typography>
                <Typography variant="subtitle1">
                інструції щодо налаштування:
                </Typography>
                <List>
                <ListItem>
                  <ListItemText secondary="•	МШ (доступ до крипто-мережі Мінсоцполітики України)," />
                  </ListItem>  
                  <ListItem>
                  <ListItemText secondary="•	ПЗ “КриптоАвтограф”," />
                  </ListItem>
                  <ListItem>
                  <ListItemText secondary="•	крипто-пошти" />
                  </ListItem>
                  
                </List>
                <Typography variant="subtitle1">
                інструкції по підключенню до Комплексу, включаючи порядок реєстрації та авторизації
                </Typography>
                <Button onClick={handleLogout} variant="contained" color="primary">На головну</Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {getStepContent(activeStep, props, handleNext, handleNextTable, handleBack, validity, handleSubmit)}
               
                {/* <div className={classes.buttons}>
                  {activeStep !== 0 && (
                    <Button 
                    variant="contained"
                    color="primary" 
                    onClick={handleBack} 
                    className={classes.button}>
                      Назад
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={activeStep === steps.length - 1 ? handleSubmit: handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Подати' : 'Далі'}
                  </Button>
                </div> */}
              </React.Fragment>
            )}
          </React.Fragment>
          {/* </Grid> */}
       
        </Paper>
        </Grid>
        <Copyright />
      </main>
    </React.Fragment>
  );
})